const STATIC_ASSETS_URL = 'https://assets.homedepot-static.com/images/v1/';
export const SupportedDocuments = [{
  name: 'Full Product Details',
  displayName: 'Full Product Details',
  image: `${STATIC_ASSETS_URL}product-details.svg`,
  openCard: true,
  cardSectionName: 'product-overview',
  scrollToBottom: false
}, {
  name: 'Specifications',
  displayName: 'Specifications',
  image: `${STATIC_ASSETS_URL}specifications.svg`,
  openCard: true,
  cardSectionName: 'specifications',
  scrollToBottom: false
}, {
  name: 'Warranty',
  displayName: 'Warranty',
  image: `${STATIC_ASSETS_URL}warranty.svg`
}, {
  name: 'Use and Care Manual',
  displayName: 'Use and Care',
  image: `${STATIC_ASSETS_URL}use-and-care-manual.svg`
}, {
  name: 'Returns',
  displayName: 'Returns',
  image: `${STATIC_ASSETS_URL}returns.svg`
}, {
  name: 'Info & Guides',
  displayName: 'Info & Guides',
  image: `${STATIC_ASSETS_URL}info-icon.svg`,
  openCard: true,
  cardSectionName: 'product-overview',
  scrollToBottom: true
}];
